import { createFileRoute } from '@tanstack/react-router'
import { AdministrationFeatureTogglesPage } from '@/pages/administration/administration-feature-toggles-page'

export const Route = createFileRoute('/administration/feature-toggles')({
  component: AdministrationFeatureTogglesPage,
})
